var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisabledVeteranBgMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 449,
    viewBox: "0 0 375 449",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3104_5534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375 -77H0V449H375V-77Z",
    fill: "url(#paint0_radial_3104_5534)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.731 115.243L156.039 72V316.163H197.731V115.243Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.631 115.243L148.323 72V316.163H106.631V115.243Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3879 155.955V292.586C67.3879 318.584 88.6489 342.762 114.643 342.762H188.94C214.934 342.762 236.195 318.584 236.195 292.586V155.139L212.007 130.044L213.041 296.97C213.041 325.794 192.799 331.765 168.043 331.765H134.52C109.764 331.765 90.2071 325.255 90.2071 296.97V132.287L67.3879 155.955Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.333 186.404L266.551 296.761C266.551 334.047 236.058 364.545 198.778 364.545H103.759C66.4791 364.545 35.9855 334.047 35.9855 296.761L36.1457 187.686L54.1302 169.699V294.795C54.1302 326.837 80.3425 353.054 112.38 353.054H190.172C222.209 353.054 248.436 326.837 248.436 294.795V167.834L266.348 186.404H266.333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293 214.059V306.836C293 350.923 256.929 387 212.849 387H88.1512C44.071 387 8 350.923 8 306.836L8.20387 217.321L26.7563 197.717V303.559C26.7563 342.782 58.8372 374.868 98.0536 374.868H204.49C243.706 374.868 275.787 342.782 275.787 303.559L276.18 196.566L292.985 214.044L293 214.059Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter0_b_3104_5534)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 449,
    fill: "#081E54"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_3104_5534",
    x: -60,
    y: -60,
    width: 495,
    height: 569,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 30
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_3104_5534"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_3104_5534",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3104_5534",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(191.568 135.565) scale(323.008 320.354)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B6BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#0A66B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#064385"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#03285E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#011442"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#000831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00042B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3104_5534"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 449,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledVeteranBgMobile);
export default __webpack_public_path__ + "static/media/DisabledVeteranBgMobile.fba2c44d65ca94199763b68308dd0529.svg";
export { ForwardRef as ReactComponent };